import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var removeFromList = function removeFromList(_ref) {
  var list = _ref.list,
    key = _ref.key;
  var i = list.indexOf(key);
  if (i < 0) return list;
  var newList = _toConsumableArray(list);
  newList.splice(i, 1);
  return newList;
};
export var addToList = function addToList(_ref2) {
  var list = _ref2.list,
    key = _ref2.key;
  return !list.includes(key) ? [].concat(_toConsumableArray(list), [key]) : list;
};
export var removeFromMap = function removeFromMap(_ref3) {
  var map = _ref3.map,
    key = _ref3.key;
  var newMap = _objectSpread({}, map);
  delete newMap[key];
  return newMap;
};